<template>
  <el-container class="con">
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but5" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but5" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main style="margin-top: -10px">
      <span class="text2"><img class="icon_product" src="@/assets/images/icon_product.png" alt=""/>完成订单</span>
      <el-steps :active="4" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 产品选择" icon="el-icon-thumb"></el-step>
        <el-step title="2 购物车确认" icon="el-icon-shopping-cart-full"></el-step>
        <el-step title="3 完善订单信息" icon="el-icon-edit"></el-step>
        <el-step title="4 提交完成订单" icon="el-icon-document-checked"></el-step>
      </el-steps>
      <div class="main">
        <img class="img" src="@/assets/images/successOrder.png" alt=""/>
        <p class="p1">订单已生成</p>
        <div class="p">
          <p class="p2">客&emsp;户&emsp;姓&emsp;名：&emsp;<span class="sp">{{customerName}}</span></p>
          <p class="p2">您的订单编号：<span class="sp1">{{billNumber}}</span></p>
          <p class="p2" v-if="billAmount !== '' && billAmount !== null">您的订单金额：<span class="sp1">{{billAmount}}</span></p>
          <p class="p2" v-if="billBalance !== ''">账&emsp;户&emsp;余&emsp;额：&emsp;<span class="sp1">{{billBalance}}元</span></p>
        </div>
        <div class="button">
          <el-button class="but but2">
            <span class="sp2" @click="toPay(billAmount)">去支付订单</span>
          </el-button>
          <el-button class="but but3">
            <span class="sp2" @click="toBuy">继续购物</span>
          </el-button>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: "index",
  data(){
    return{
      currentUser:'',
      saleOrgName:'',
      customerName:'',
      billNumber:'',
      billAmount:'',
      billBalance:'',
      currentUserName:'',
      selectedCustomer:''
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
    this.selectedCustomer = this.$route.params.selectedCustomer
    this.customerName = this.$route.params.billCustomer
    this.billNumber = this.$route.params.billNumber
    this.billAmount = this.$route.params.billAmount === '' ? '' : this.$route.params.billAmount
    this.billBalance = this.$route.params.billBalance === '' ? '' : this.$route.params.billBalance
  },
  methods:{
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    toPay(val){
      if(val <= 0){
        this.$message.warning('付款金额错误，请重试')
        return
      }
      this.$router.push({ path: "/finance/pay",query:{amount:val,selectedCustomer:this.selectedCustomer}});
    },
    toBuy(){
      this.$router.push({ path: "/product/buyFeed"})
    }
  }
}
</script>

<style scoped>
  .title{
    margin-top: 10px;
    margin-left: 20px;
  }
  .three_lever{
    width: 14px;
    height: 16px;
  }
  .text{
    color: rgb(239, 51, 69);
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    margin: 0 8px;
  }
  .text2{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
  .main{
    text-align: center;
    width: 99%;
    height: 70vh;
    border: 1px solid rgb(196, 196, 196);
    margin: 10px auto;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but5{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .but1{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
  }
  .img{
    margin-top: 50px;
    width: 153px;
    height: 127px;
  }
  .p{
    width: 350px;
    margin: 20px auto;
  }
  .p1{
    margin-left: 10px;
    color: rgb(239, 51, 69);
    font-size: 16px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 3px;
  }
  .p2{
    color: rgb(71, 71, 71);
    font-size: 13px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 1px;
    text-align: left;
  }
  .justify{
    text-align-last: justify;
  }
  .button{
    width: 300px;
    margin: 30px auto;
    text-align: left;
  }
  .but{
    width: 144px;
    border-radius: 20px;
    border: none;
    height: 40px;
  }
  .but2{
    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1) 0%,rgba(253,131,145,1) 100%);
  }
  .but3{
    background: linear-gradient(180.00deg, rgba(85,136,249,1) 0%,rgba(102,162,253,1) 100%);
  }
  .sp{
    font-weight: bold;
  }
  .sp1{
    font-weight: bold;
    color: rgb(240, 57, 74);
  }
  .sp2{
    color: rgb(255, 255, 255);
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_product{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    max-width: 100%;
  }
</style>
